import { useQuery } from "react-query";
import { getCarrierContacTypes } from "../../../../actions/CarrierAgreementMgmt/Carrier";

//Fetching Carrier Contact Types

export const useGetCarrierContactTypes = () => {
  return useQuery("GetCarrierContactTypes", getCarrierContacTypes, {
    refetchOnWindowFocus: false,
  });
};
